import { useId } from 'react'

/**
 * EDIMI brand mark — the 3-bar "Korektor E" sygnet (spec: branding/README.md).
 * tone="brand" = gradient marki --grad (#6c5ce7 → #d6266b, ten sam róż co w tokenach — MAPA decyzja 2),
 * tone="white" = mono na scenie (--stage-fg).
 */
export function LogoMark({ size = 20, tone = 'brand' }: { size?: number; tone?: 'brand' | 'white' }) {
  const id = useId()
  const fill = tone === 'white' ? '#ffffff' : `url(#${id})`
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
      {tone === 'brand' && (
        <defs>
          <linearGradient id={id} x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#6c5ce7" />
            <stop offset="1" stopColor="#d6266b" />
          </linearGradient>
        </defs>
      )}
      <rect x="8" y="11" width="48" height="12" rx="6" fill={fill} />
      <rect x="8" y="26" width="30" height="12" rx="6" fill={fill} />
      <rect x="8" y="41" width="44" height="12" rx="6" fill={fill} />
    </svg>
  )
}

/**
 * Full lockup: sygnet + lowercase "edimi" wordmark. The parent (.logo / .sidebar-logo)
 * supplies flex layout, font size and text color.
 */
export default function Logo({ size = 20, tone = 'brand' }: { size?: number; tone?: 'brand' | 'white' }) {
  return (
    <>
      <LogoMark size={size} tone={tone} />
      <span className="logo-word">edimi</span>
    </>
  )
}
